import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { ClickGallery, ClickGalleryLink, CloudConnection, ElementsUserLookup } from 'elements-sdk'
import { APIService } from 'api'
import { ModalComponent } from 'common/util.modals'
import { TranslateDirective } from 'common/locale/directives/translate.directive'
import { CheckboxComponent } from 'common/util/components/checkbox.component'
import { ClickBlockingDirective } from 'common/util/directives/clickBlocking.directive'
import { NaturalOrderByPipe } from 'common/util/pipes/naturalOrderBy.pipe'
import { TranslatePipe } from 'common/locale'
import { IdentityService } from 'main/services/identity.service'

interface Params {
  readonly gallery: ClickGallery
  readonly connection: CloudConnection
}

interface Result {
  clickGalleryLink: ClickGalleryLink
  sendEmail: boolean
}

@Component({
  selector: 'create-click-link-modal',
  templateUrl: './createClickLinkModal.component.html',
  imports: [
    FormsModule,
    TranslateDirective,
    CheckboxComponent,
    ClickBlockingDirective,
    NaturalOrderByPipe,
    TranslatePipe,
  ],
})
export class CreateClickLinkModalComponent extends ModalComponent<Params, Result> {
  type: 'email' | 'anonymous' | 'user' = 'email'
  email = ''
  viewLimit = null
  sendEmail = true
  notifyOnUse = false
  users?: ElementsUserLookup[]

  gallery: ClickGallery
  connection: CloudConnection

  constructor (
    public identity: IdentityService,
    private api: APIService,
  ) {
    super()
    this.notifyOnUse = !!identity.user?.email
    this.gallery = this.params.gallery
    this.connection = this.params.connection
  }

  async ngOnInit () {
    this.users = (await this.api.main.lookupUsers()).filter(x => !!x.email)
  }

  readonly create = async () => {
    let link: ClickGalleryLink = {
      email: this.type === 'anonymous' ? null : this.email,
      galleryId: this.gallery.id,
      expiresAt: null,
      notifyOnUse: this.notifyOnUse,
      viewsLeft: this.viewLimit,
    }
    link = await this.api.click.createClickGalleryLink({
      connectionId: this.connection.id.toString(),
      clickGalleryLink: link,
    })
    this.complete({
      clickGalleryLink: link,
      sendEmail: this.sendEmail,
    })
  }
}
